"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1.1 8a6.894 6.894 0 0 1 6.886-6.886c3.797 0 6.885 3.09 6.885 6.886a6.893 6.893 0 0 1-6.885 6.885A6.893 6.893 0 0 1 1.1 8Zm-1 0c0 4.348 3.538 7.885 7.886 7.885 4.349 0 7.885-3.537 7.885-7.885S12.334.114 7.986.114.1 3.652.1 8Zm4.476.456 5.192 3.815.592-.807-4.65-3.417 4.655-3.516-.602-.798-5.192 3.921a.5.5 0 0 0 .005.802Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1.409 12c0-5.878 4.782-10.659 10.659-10.659 5.877 0 10.659 4.781 10.659 10.66 0 5.876-4.782 10.658-10.66 10.658C6.192 22.66 1.41 17.877 1.41 12ZM.284 12c0 6.497 5.286 11.784 11.784 11.784 6.498 0 11.784-5.287 11.784-11.784 0-6.498-5.286-11.784-11.784-11.784C5.57.216.284 5.502.284 12Zm6.72.534 7.888 5.796.666-.907-7.28-5.348 7.286-5.502-.678-.898-7.889 5.956a.565.565 0 0 0 .006.903Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1.878 16c0-7.837 6.376-14.212 14.212-14.212 7.836 0 14.212 6.375 14.212 14.212 0 7.836-6.376 14.212-14.212 14.212-7.836 0-14.212-6.376-14.212-14.212Zm-1.5 0c0 8.663 7.048 15.712 15.712 15.712S31.802 24.663 31.802 16C31.802 7.336 24.754.288 16.09.288S.378 7.336.378 16Zm8.96.712 10.519 7.727.887-1.209-9.707-7.13 9.716-7.337-.904-1.197-10.52 7.942a.753.753 0 0 0 .008 1.204Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M2.625 23.797c0-11.674 9.498-21.172 21.172-21.172 11.674 0 21.171 9.498 21.171 21.172 0 11.674-9.498 21.171-21.171 21.171-11.674 0-21.172-9.498-21.172-21.171Zm-1.875 0c0 12.708 10.339 23.046 23.047 23.046s23.046-10.338 23.046-23.046S36.505.75 23.797.75.75 11.089.75 23.797Zm13.17.914 15.542 11.42 1.11-1.512-14.528-10.674 14.539-10.978-1.13-1.496L13.91 23.208a.937.937 0 0 0 .01 1.503Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M3.5 31.729C3.5 16.164 16.164 3.5 31.729 3.5s28.229 12.664 28.229 28.229-12.664 28.229-28.229 28.229S3.5 47.294 3.5 31.729Zm-2.5 0c0 16.944 13.785 30.729 30.729 30.729s30.729-13.785 30.729-30.729S48.673 1 31.729 1 1 14.785 1 31.729Zm17.56 1.218 20.723 15.226 1.48-2.015-19.37-14.232L40.776 17.29l-1.507-1.995-20.724 15.65a1.25 1.25 0 0 0 .013 2.003Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconCaretCircleLeft = function IconCaretCircleLeft(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Caret Circle Left' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "CaretCircleLeft"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconCaretCircleLeft.sizes = [16, 24, 32, 48, 64];
IconCaretCircleLeft.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconCaretCircleLeft;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/system/CaretCircleLeft.js
// module id = 2325
// module chunks = 0